import { Navigate, Route, Routes } from "react-router-dom";
import MainLayout from "./components/layout/MainLayout";
import ProtectedRoute from "./routes/ProtectedRoute";
import Login from "./pages/auth/Login";
import Dashboard from "./pages/dashboard/Dashboard";
import CompanySetup from "./pages/crm/settings/company/CompanySetup";
import FinancialYear from "./pages/crm/settings/financial-years/FinancialYear";
import Users from "./pages/crm/settings/users/Users";
import RolesPermissions from "./pages/crm/settings/roles-permissions/RolesPermissions";
const PlaceholderPage = ({ title }) => (
  <div style={{ background: "#FFFFFF", border: "1px solid #E4E7EC", borderRadius: "12px", padding: "24px", }}>
    <h2 style={{ margin: 0, color: "#333333", fontSize: "20px", }}>{title}</h2>
    <p style={{ color: "#667085", marginTop: "8px", }}>This module will be developed next.</p>
  </div>
);

function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route element={<ProtectedRoute />}>
        <Route element={<MainLayout />}>
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/crm/leads" element={<PlaceholderPage title="Leads" />} />
          <Route path="/crm/follow-ups" element={<PlaceholderPage title="Follow-ups" />} />
          <Route path="/crm/customers" element={<PlaceholderPage title="Customers" />} />
          <Route path="/crm/activities" element={<PlaceholderPage title="Activities" />} />
          <Route path="/sales/quotations" element={<PlaceholderPage title="Quotations" />} />
          <Route path="/sales/orders" element={<PlaceholderPage title="Sales Orders" />} />
          <Route path="/sales/invoices" element={<PlaceholderPage title="Invoices" />} />
          <Route path="/sales/receipts" element={<PlaceholderPage title="Receipts" />} />
          <Route path="/sales/credit-notes" element={<PlaceholderPage title="Credit Notes" />} />
          <Route path="/sales/debit-notes" element={<PlaceholderPage title="Debit Notes" />} />
          <Route path="/sales/payments" element={<PlaceholderPage title="Customer Payments" />} />
          <Route path="/sales/receivables" element={<PlaceholderPage title="Receivables" />} />
          <Route path="/purchase/vendors" element={<PlaceholderPage title="Vendors" />} />
          <Route path="/purchase/bills" element={<PlaceholderPage title="Purchase Bills" />} />
          <Route path="/purchase/returns" element={<PlaceholderPage title="Purchase Returns" />} />
          <Route path="/purchase/payments" element={<PlaceholderPage title="Vendor Payments" />} />
          <Route path="/purchase/payables" element={<PlaceholderPage title="Payables" />} />
          <Route path="/expenses" element={<PlaceholderPage title="Expenses" />} />
          <Route path="/projects" element={<PlaceholderPage title="Projects" />} />
          <Route path="/projects/tasks" element={<PlaceholderPage title="Project Tasks" />} />
          <Route path="/projects/milestones" element={<PlaceholderPage title="Project Milestones" />} />
          <Route path="/support/tickets" element={<PlaceholderPage title="Support Tickets" />} />
          <Route path="/support/amc" element={<PlaceholderPage title="AMC" />} />
          <Route path="/support/renewals" element={<PlaceholderPage title="Renewals" />} />
          <Route path="/reports/sales" element={<PlaceholderPage title="Sales Report" />} />
          <Route path="/reports/purchase" element={<PlaceholderPage title="Purchase Report" />} />
          <Route path="/reports/expenses" element={<PlaceholderPage title="Expense Report" />} />
          <Route path="/reports/payments" element={<PlaceholderPage title="Payment Report" />} />
          <Route path="/reports/gst" element={<PlaceholderPage title="GST Report" />} />
          <Route path="/reports/profit-loss" element={<PlaceholderPage title="Profit & Loss" />} />
          <Route path="/masters/services" element={<PlaceholderPage title="Services" />} />
          <Route path="/masters/packages" element={<PlaceholderPage title="Packages" />} />
          <Route path="/masters/lead-sources" element={<PlaceholderPage title="Lead Sources" />} />
          <Route path="/masters/lead-status" element={<PlaceholderPage title="Lead Status" />} />
          <Route path="/masters/expense-categories" element={<PlaceholderPage title="Expense Categories" />} />
          <Route path="/masters/payment-modes" element={<PlaceholderPage title="Payment Modes" />} />
          <Route path="/masters/tax-rates" element={<PlaceholderPage title="Tax Rates" />} />
          <Route path="/settings/company" element={<CompanySetup />} />
          <Route path="/settings/financial-years" element={<FinancialYear />} />
          <Route path="/settings/users" element={<Users />} />
          <Route path="/settings/roles" element={<RolesPermissions />} />
        </Route>
        <Route path="*" element={<Navigate to="/login" replace />
        }
        />
      </Route>
    </Routes>
  );
}

export default App;